import type { Translation } from '../../types';
import type { declarations as en } from '../en/declarations';

export const declarations: Translation<typeof en> = {
  status: {
    GENERATED: 'Đã tạo',
    UPLOADED: 'Đã tải lên, đang kiểm tra',
    VERIFIED: 'Đã chấp nhận (chữ ký số)',
    REVIEW_REQUIRED: 'Chờ nhân viên duyệt',
    APPROVED: 'Nhân viên đã duyệt',
    REJECTED: 'Cần bổ sung',
  },
  uploadStatus: {
    PENDING: 'Đang kiểm tra',
    VERIFIED: 'Tự động chấp nhận',
    REVIEW_REQUIRED: 'Chờ duyệt',
    APPROVED: 'Đã duyệt',
    REJECTED: 'Không chấp nhận',
    SUPERSEDED: 'Đã được thay bằng bản tải lên mới',
  },
  uploadKind: { SIGNED_PDF: 'PDF ký số', SCAN: 'Bản quét / ký tay' },
  checkStatus: { PASS: 'Đạt', FAIL: 'Không đạt', UNKNOWN: 'Chưa xác định' },
  check: {
    DECLARED_DATA: 'Dữ liệu khai báo không đổi',
    TEMPLATE_VERSION: 'Còn phiên bản mẫu',
    PDF_STRUCTURE: 'PDF không có nội dung chủ động',
    SIGNATURE_PRESENT: 'Có chữ ký số',
    SIGNATURE_FORMAT: 'Định dạng chữ ký (CMS / CAdES)',
    SIGNATURE_COVERS_FILE: 'Chữ ký phủ toàn bộ tệp',
    SAME_AS_GENERATED: 'Đúng nội dung bản khai đã tạo',
    CMS_SIGNATURE_VALID: 'Chữ ký hợp lệ về mật mã',
    DIGEST_MATCHES: 'Không bị sửa sau khi ký',
    KEY_USAGE: 'Chứng thư dùng để ký',
    SIGNING_TIME: 'Thời điểm ký',
    SIGNATURE_TIMESTAMP: 'Dấu thời gian (RFC 3161)',
    FORM_PURPOSE: 'Loại biểu mẫu (hoàn trả / xác nhận của cha mẹ: nhân viên quyết định)',
    VERIFICATION_PATH: 'Đúng cách xác thực theo loại chủ thể (cá nhân: eKYC; tổ chức: bản khai chủ thể)',
    signature: 'Chữ ký {{n}}',
    documentTimestamp: 'Dấu thời gian tài liệu {{n}}',
    CHAIN_TRUSTED: 'Chuỗi chứng thư tới CA Việt Nam được tin cậy',
    NOT_REVOKED: 'Chứng thư chưa bị thu hồi (OCSP / CRL)',
    SIGNER_IDENTITY: 'Người ký là chủ thể (CCCD / MST)',
    SIGNER_NAME: 'Tên trong chứng thư',
    SCAN_IMAGE: 'Ảnh trang đọc được',
    QR_CODE: 'Mã QR của bản khai này',
    OCR: 'Đọc chữ tại máy chủ (OCR)',
    field: 'Trường: {{label}}',
  },
  // `FIELD:<key>` when the check does not carry its template label (the dossier queue's failed checks).
  fieldName: {
    address: 'Địa chỉ liên hệ',
    birth_date: 'Ngày sinh',
    business_address: 'Địa chỉ hộ kinh doanh',
    business_name: 'Tên hộ kinh doanh',
    domains: 'Tên miền',
    head_office: 'Địa chỉ trụ sở chính',
    household_code: 'Mã số đăng ký hộ kinh doanh',
    id_number: 'Số định danh cá nhân / hộ chiếu',
    legal_name: 'Họ và tên',
    minor_name: 'Họ tên người được giám hộ',
    org_name: 'Tên cơ quan, tổ chức',
    owner_name: 'Họ tên chủ hộ kinh doanh',
    permanent_address: 'Địa chỉ thường trú',
    rep_id_number: 'Số định danh người đại diện',
    rep_name: 'Họ tên người đại diện',
    tax_code: 'Mã số thuế',
  },
  checks: {
    title: 'Kết quả kiểm tra',
    check: 'Kiểm tra',
    result: 'Kết quả',
    reason: 'Lý do',
    empty: 'Chưa kiểm tra.',
    allPass: 'Mọi kiểm tra đều đạt.',
    attention: '{{count}} kiểm tra cần xem lại.',
    noTimestamp: 'Thời điểm ký theo khai báo của người ký (không có dấu thời gian).',
  },
  sig: {
    signer: 'Người ký',
    ca: 'CA cấp',
    signingTime: 'Thời điểm ký (khai báo)',
    timestamp: 'Dấu thời gian',
    timestampValid: 'có, hợp lệ',
    timestampInvalid: 'có, không hợp lệ',
    noTimestamp: 'không có',
    covers: 'Phạm vi ký',
    wholeDocument: 'toàn bộ tài liệu',
    partOfDocument: 'một phần tài liệu (có nội dung thêm sau khi ký)',
    byteRange: 'Byte range',
    valid: 'Hợp lệ',
    yes: 'có',
    no: 'không',
  },
  trust: {
    title: 'Chứng chỉ gốc tin cậy',
    description: 'Các chứng thư CA mà admin-api đã nạp để kiểm tra chữ ký số trên bản khai (và dấu thời gian). Chỉ xem; thêm / bớt bằng file rồi khởi động lại.',
    loadError: 'Không tải được kho chứng thư tin cậy',
    count: 'Chứng thư gốc đã nạp',
    allowList: 'Vân tay trong danh sách cho phép',
    noExtraDir: 'Chưa cấu hình thư mục trên máy chủ',
    emptyTitle: 'Kho chứng thư tin cậy đang trống',
    emptyBody: 'Chưa có chứng thư gốc nào: mọi bản khai ký số sẽ chuyển nhân viên duyệt.',
    howTo: 'Nguồn: {{dir}} (trong mã nguồn) và {{extra}} (trên máy chủ, tải bằng subsystems/identity/modules/declarations/tools/fetch-vn-ca.sh). Chứng thư trên máy chủ chỉ được dùng khi vân tay SHA-256 của nó có trong trusted-fingerprints.txt — kiểm tra vân tay qua kênh thứ hai (NEAC) trước khi thêm, rồi khởi động lại api, admin-api, identity-worker.',
    anchors: 'Chứng thư đang dùng',
    subject: 'Chứng thư',
    issuer: 'Cấp bởi',
    selfSigned: 'tự ký (gốc)',
    validity: 'Hiệu lực',
    expired: 'hết hạn',
    fingerprint: 'Vân tay SHA-256',
    file: 'File',
    sourceRepo: 'mã nguồn',
    sourceExtra: 'máy chủ (đã cho phép)',
    ignored: 'Chứng thư tìm thấy nhưng không dùng',
    ignoredDescription: 'Không có trong danh sách cho phép, hoặc không phải chứng thư CA.',
    reason: 'Lý do',
    ignoredReason: { NOT_IN_ALLOWLIST: 'chưa có trong trusted-fingerprints.txt', NOT_A_CA: 'không phải chứng thư CA' },
  },
  documentTypes: {
    title: 'Loại hồ sơ',
    description: 'Danh sách loại hồ sơ của tên miền: ai tải lên, định dạng tệp, đuôi tên miền áp dụng và loại hồ sơ tương ứng trên VNNIC. Ô tải hồ sơ ở trang tên miền, các hồ sơ bắt buộc và tệp gửi VNNIC đều theo danh sách này.',
    col: { name: 'Tên', type: 'Kiểu', extensions: 'Định dạng', tlds: 'Đuôi tên miền', actions: 'Thao tác' },
    badge: { download: 'Có mẫu tải về', required: 'Bắt buộc', requiredFor: 'Bắt buộc: {{ops}}', individual: 'Cá nhân', organization: 'Tổ chức', ekyc: 'eKYC', onlyDownload: 'Khách chỉ tải mẫu', onlyAdmin: 'Chỉ nhân viên', autoSign: 'NĐK ký tự động' },
    flag: { download: 'Có mẫu để tải về', ekyc: 'Lấy từ eKYC', onlyDownload: 'Khách chỉ tải mẫu (nhân viên tải lên)', onlyAdmin: 'Chỉ nhân viên', active: 'Đang dùng' },
    field: {
      nameVi: 'Tên (tiếng Việt)',
      nameEn: 'Tên (tiếng Anh)',
      flags: 'Kiểu',
      required: 'Bắt buộc',
      requiredToggle: 'Hồ sơ phải có loại này trước khi gửi lệnh tới registry',
      requiredOps: 'Bắt buộc với nghiệp vụ',
      requiredHint: 'Áp dụng đúng phạm vi bên dưới (đuôi tên miền và chủ thể), cho mọi đuôi — .vn và tên miền quốc tế. Loại lấy từ eKYC được tính là đủ khi chủ thể đã eKYC; bản khai tên miền khi hồ sơ có bản khai (tự sinh, bản khai chủ thể hoặc bản khách ký).',
      subjects: 'Áp dụng cho chủ thể',
      hstmFile: 'Hồ sơ (loại tệp trên VNNIC)',
      hstmDocument: 'Loại hồ sơ (trên VNNIC)',
      methods: 'Hình thức xác thực áp dụng',
      methodsHint: 'Không chọn: áp dụng mọi hình thức. Chỉ dùng cho tệp gửi VNNIC (HSTM); bắt buộc hay không theo mục "Bắt buộc".',
      extensions: 'Định dạng tệp cho phép',
      extensionsHint: 'Gõ rồi nhấn Enter: pdf, png, jpg, jpeg.',
      maxSize: 'Dung lượng tối đa (MB)',
      template: 'Mẫu',
      tlds: 'Áp dụng cho đuôi',
      zoneFilter: 'Lọc đuôi…',
    },
    subject: { ALL: 'Tất cả', INDIVIDUAL: 'Cá nhân', ORGANIZATION: 'Tổ chức (mọi chủ thể không phải cá nhân)' },
    zonesPicked: 'Đã chọn {{n}} đuôi',
    zonesLoading: 'Đang tải danh sách đuôi…',
    operation: { REGISTER: 'Đăng ký mới', CHANGE_INFORMATION: 'Thay đổi thông tin', CHANGE_REGISTRANT_NAME: 'Đổi tên chủ thể', RETURN: 'Hoàn trả tên miền', TRANSFER_RIGHT_OF_USE: 'Chuyển nhượng quyền sử dụng', CHANGE_REGISTRAR: 'Chuyển đổi nhà đăng ký' },
    none: '— Không có —',
    noTemplate: 'Loại hồ sơ này chưa có mẫu',
    editTemplate: 'Sửa mẫu',
    allTlds: 'Mọi đuôi',
    allTldsShort: 'Mọi đuôi',
    someTlds: 'Chọn đuôi',
    hstmShort: 'Hồ sơ VNNIC #{{n}}',
    signAuto: 'Nhà đăng ký ký số tự động trên mọi hồ sơ',
    signOptional: 'Nhà đăng ký ký khi nhân viên gửi ký',
    updated: 'Cập nhật {{at}} bởi {{by}}',
    edit: 'Sửa',
    view: 'Xem',
    editHint: 'Thay đổi được ghi nhật ký kèm lý do.',
    save: 'Lưu',
    readOnly: 'Chỉ cán bộ tuân thủ được sửa loại hồ sơ.',
    empty: 'Chưa có loại hồ sơ nào',
  },
  checkSettings: {
    title: 'Kiểm tra bản khai',
    description: 'Bản khai tải lên không đạt kiểm tra thì làm gì: chuyển nhân viên kiểm tra (mặc định) hay tự động từ chối, báo lý do cho khách hàng. Từng loại lỗi được chỉnh riêng; mọi thay đổi được ghi nhật ký kèm lý do.',
    rootCa: 'Chứng chỉ gốc (CA) không có trong kho tin cậy không bao giờ là lỗi: bản khai ký số được tự động chấp nhận khi chữ ký toàn vẹn và phủ toàn bộ tài liệu, MST / CCCD trong chứng thư đúng của chủ thể và chứng thư còn hiệu lực lúc ký; chuỗi chứng thư chỉ ghi nhận để tham khảo.',
    section: 'Khi bản khai không đạt',
    modes: { STAFF_REVIEW: 'Cần nhân viên kiểm tra', AUTO_REJECT: 'Tự động từ chối, báo lý do cho khách hàng' },
    kinds: {
      integrity_failure: { label: 'Chữ ký không toàn vẹn', hint: 'Chữ ký số không hợp lệ, hoặc tệp đã bị sửa (không đúng bản khai đã tạo).' },
      coverage_failure: { label: 'Chữ ký không phủ toàn bộ tài liệu', hint: 'Có nội dung thêm sau chữ ký cuối cùng.' },
      identifier_mismatch: { label: 'Người ký không phải chủ thể', hint: 'MST / CCCD hoặc tên trong chứng thư số không khớp chủ thể.' },
      paper_rejected: { label: 'Bản giấy là tài liệu khác', hint: 'Đọc tại máy chủ (OCR) thấy là bản khai khác hoặc không có thông tin của chủ thể.' },
    },
    save: 'Lưu',
    readOnly: 'Chỉ người có quyền “Can thiệp một quyết định tuân thủ nghiêm trọng” được thay đổi.',
    updated: 'Cập nhật {{at}} bởi {{by}}',
    someone: 'một nhân viên',
  },
  vnZones: {
    title: 'Quy định theo đuôi .vn',
    description: 'Ai được đăng ký từng đuôi .vn, giấy tờ thêm, kích hoạt thủ công, mã khuyến mại VNNIC — định nghĩa trong config/vn-zones.yaml (chỉ xem).',
    loadError: 'Không tải được quy định .vn',
    fileNote: 'Phiên bản {{version}}, file {{source}}: sửa file rồi khởi động lại admin-api, api, domain-worker.',
    unconfirmedCount: '{{count}} quy định chưa được chủ doanh nghiệp xác nhận với văn bản gốc.',
    ruleTitle: 'Quy định đăng ký (.vn)',
    fileDefined: 'Theo config/vn-zones.yaml.',
    defaultsApply: 'Đuôi này không có mục riêng: áp dụng quy định mặc định.',
    zone: 'Đuôi',
    defaults: '(mặc định)',
    registrantTypes: 'Loại chủ thể được đăng ký',
    nationalities: 'Quốc tịch',
    any: 'mọi quốc tịch',
    manualActivation: 'Kích hoạt',
    manual: 'thủ công (nhân viên duyệt)',
    automatic: 'tự động',
    promoCode: 'Mã khuyến mại VNNIC',
    promoNone: 'không áp dụng',
    promo: { eligible: 'được dùng', required: 'bắt buộc' },
    documents: 'Giấy tờ thêm',
    formOnly: 'chỉ bản khai theo loại chủ thể',
    source: 'Căn cứ',
    status: 'Xác nhận',
    confirmed: 'đã xác nhận',
    unconfirmed: 'chưa xác nhận',
    type: { INDIVIDUAL: 'cá nhân', ORGANISATION: 'tổ chức, doanh nghiệp', HOUSEHOLD_BUSINESS: 'hộ kinh doanh', STATE_AGENCY: 'cơ quan nhà nước' },
  },
  templates: {
    title: 'Mẫu bản khai',
    description: 'Các mẫu "bản khai đăng ký tên miền" hệ thống tạo ra, với các trường lấy từ dữ liệu chủ thể.',
    fileDefined: 'Định nghĩa trong file ({{source}}): sửa file YAML rồi khởi động lại admin-api, api và identity-worker. Không sửa ở đây.',
    loadError: 'Không tải được danh sách mẫu bản khai',
    form: 'Mẫu',
    version: 'Phiên bản',
    file: 'File',
    subjectTypes: 'Chủ thể',
    legalBasis: 'Căn cứ',
    source: 'Nguồn bố cục',
    layoutChecked: 'Bố cục đã đối chiếu với mẫu chính thức',
    layoutNotChecked: 'Bố cục cần đối chiếu với mẫu chính thức',
    preview: 'Xem trước PDF (dữ liệu mẫu)',
    fields: 'Các trường',
    label: 'Nhãn',
    key: 'Khoá',
    binding: 'Lấy từ',
    required: 'Bắt buộc',
    compare: 'So khớp trên bản quét',
    sensitive: 'Che',
    fixedText: 'Nội dung cố định',
    blank: 'Để trống (điền tay)',
    signature: 'Phần ký',
    trustTitle: 'Tổ chức chứng thực được tin cậy',
    trustDescription: 'Chữ ký số phải có chuỗi chứng thư tới một trong các chứng thư này ({{dir}}). Các file nằm trong mã nguồn; xem README để thêm CA.',
    trustEmpty: 'Kho chứng thư tin cậy đang trống: mọi bản khai ký số đều chuyển nhân viên duyệt.',
    trustFile: 'File',
    trustSubject: 'Chứng thư',
    trustFingerprint: 'Dấu vân tay SHA-256',
  },
  subject: {
    purpose: 'Loại biểu mẫu',
    purposes: {
      SUBJECT_DECLARATION: 'Bản khai chủ thể (tổ chức, ký một lần)',
      REGISTRATION: 'Đăng ký (Mẫu 01a / 01b / 01c)',
      PARENTAL_CONSENT: 'Xác nhận của cha, mẹ, người giám hộ (Mẫu 02)',
      RETURN: 'Hoàn trả tên miền (Mẫu 03a / 03b / 03c)',
    },
    purposeHint: {
      SUBJECT_DECLARATION: 'Tổ chức ký số một lần bản khai thông tin đăng ký của mình; mọi tên miền sau đó được tạo bản khai tự động. Không ký số được: in ra, ký tên, đóng dấu rồi tải bản quét lên — đọc tự động tại máy chủ, nhân viên duyệt. Thông tin thay đổi thì ký lại.',
      REGISTRATION: 'Mẫu theo loại chủ thể: tổ chức 01a, hộ kinh doanh 01b, cá nhân 01c. Được tạo tự động cho từng tên miền; cá nhân xác thực bằng eKYC, không tải bản ký lên.',
      PARENTAL_CONSENT: 'Người đăng ký chưa đủ 18 tuổi: cha, mẹ hoặc người giám hộ điền tay phần của mình và ký. Luôn do nhân viên duyệt.',
      RETURN: 'Một tên miền của chủ thể này và lý do hoàn trả. Luôn do nhân viên duyệt.',
    },
    returnReason: 'Lý do hoàn trả',
    tab: 'Bản khai',
    title: 'Bản khai',
    description: 'Tạo từ phiên bản hiện tại của chủ thể. Cá nhân xác thực bằng eKYC: bản khai tên miền được tạo tự động, không cần ký. Tổ chức ký bản khai chủ thể một lần (ký số, hoặc bản giấy ký tên, đóng dấu); bản khai từng tên miền được tạo tự động. NĐK chỉ ký số bản khai tên miền, sau khi kiểm tra hồ sơ.',
    generate: 'Tạo bản khai',
    generateTitle: 'Tạo bản khai',
    domains: 'Tên miền',
    domainsHint: 'Mỗi dòng một tên miền (tối đa 50). Bản khai liệt kê tất cả.',
    generated: 'Đã tạo bản khai.',
    empty: 'Chưa có bản khai',
    emptyBody: 'Tổ chức: tạo bản khai chủ thể, ký số (hoặc in ra, ký tên, đóng dấu) rồi tải bản đã ký lên.',
    created: 'Ngày tạo',
    template: 'Mẫu',
    status: 'Trạng thái',
    domainsCol: 'Tên miền',
    uploads: 'Bản đã tải lên',
    noUploads: 'Chưa tải lên bản nào.',
    download: 'PDF đã tạo',
    upload: 'Tải bản đã ký',
    uploadTitle: 'Tải lên bản khai đã ký',
    uploadHint: 'PDF đã ký số, hoặc bản quét / ảnh chụp bản in đã ký tên và đóng dấu (PDF, PNG hoặc JPEG, tối đa 20 MB). Bản giấy được đọc tại máy chủ (OCR) và đối chiếu với dữ liệu; nhân viên luôn quyết định. Nhận qua bưu điện hoặc e-mail: ghi rõ trong lý do.',
    file: 'Tệp',
    uploaded: 'Đã tải lên: hệ thống đang kiểm tra tệp.',
    viewFile: 'Xem tệp',
    workItem: 'Mở việc cần duyệt',
    signer: 'Người ký',
    signedAs: { SUBJECT: 'chủ thể', REPRESENTATIVE: 'người đại diện theo pháp luật' },
    revocation: 'Thu hồi',
    chain: 'Chuỗi chứng thư',
    signingTime: 'Thời điểm ký',
    kind: 'Loại',
  },
  read: {
    title: 'Mở tệp bản khai',
    description: 'Bản khai chứa dữ liệu định danh: lần mở được ghi nhật ký kèm lý do và cần quyền xem giấy tờ định danh.',
    reason: 'Lý do',
    reasonHint: 'Vì sao cần xem tệp (ví dụ: việc cần xử lý đang duyệt).',
    open: 'Mở',
  },
  review: {
    title: 'Bản khai đang duyệt',
    matches: 'Mọi kiểm tra tự động đều đạt. Chữ ký tay không thể xác minh bằng máy: đối chiếu bản quét với bản khai đã tạo rồi duyệt.',
    notEverything: 'Có kiểm tra không đạt hoặc chưa xác định. Xem bảng và các tệp trước khi quyết định.',
    signedNote: 'Bản khai ký số chưa đạt mọi kiểm tra.',
    scanNote: 'Bản khai giấy (ký tên, đóng dấu): đọc tự động tại máy chủ, nhân viên luôn quyết định.',
    approveEffect: 'Duyệt bản khai giấy của tổ chức xác thực chủ thể (hình thức 5 — thủ công: NĐK ký bản khai tên miền). Cá nhân chỉ xác thực bằng eKYC: không duyệt bản khai của cá nhân. Mẫu 02 / 03 có thể được chấp nhận như giấy tờ (không xác thực chủ thể); Mẫu 03 ký số hợp lệ trở thành hồ sơ "Hoàn trả tên miền" gửi VNNIC. Từ chối sẽ yêu cầu chủ thể bổ sung (gửi e-mail).',
    generated: 'Bản khai đã tạo',
    uploaded: 'Tệp đã tải lên',
    show: 'Xem song song',
    openSubject: 'Bản khai của chủ thể',
    paper: {
      title: 'Báo cáo đọc bản giấy (OCR tại máy chủ)',
      status: {
        MATCH: 'Khớp dữ liệu: nhân viên duyệt',
        MISMATCH: 'Có trường không khớp: nhân viên xem cảnh báo và quyết định',
        REJECTED: 'Không phải bản khai này: đã tự động từ chối, khách hàng được báo',
        UNREADABLE: 'Không đọc được, cần duyệt tay',
      },
      fields: 'Trường khớp: {{matched}} / {{compared}}',
      signature: 'Chữ ký',
      stamp: 'Dấu đỏ',
      detected: 'có ({{confidence}})',
      notDetected: 'không thấy',
      ocr: 'Đọc được {{lines}} dòng, độ tin cậy trung bình {{confidence}}',
      engine: 'Bộ đọc',
      staffDecides: 'Kết quả đọc tự động chỉ để tham khảo: nhân viên luôn quyết định.',
    },
  },
  verify: {
    title: 'Cách xác thực chủ thể',
    body: 'Tên miền được kích hoạt khi chủ thể đã xác thực, như nhau cho mọi tên miền: cá nhân bằng eKYC, tổ chức bằng bản khai chủ thể ký số hợp lệ (hoặc bản giấy ký tên, đóng dấu do nhân viên duyệt). Trường hợp không khớp tự động sẽ chuyển vào Việc cần xử lý.',
    ekyc: 'Cá nhân: eKYC (API eKYC của VNNIC) — cách duy nhất',
    declaration: 'Tổ chức: bản khai chủ thể ký số một lần (hoặc bản giấy ký tên, đóng dấu do nhân viên duyệt)',
    open: 'Trang chủ thể: bản khai',
  },
};
